(() => {
 if(customElements.get('flashfish-scene-slideshow')) return;
 customElements.define('flashfish-scene-slideshow',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();
   this.abort=new AbortController();
   const options={signal:this.abort.signal};
   this.slides=[...this.querySelectorAll('[data-scene-slide]')];
   this.tabs=[...this.querySelectorAll('[data-scene-tab]')];
   this.index=Math.max(0,this.slides.findIndex(s=>!s.hidden));
   this.pointer=null;
   this.swipeUntil=0;
   this.slides.forEach((s,i)=>s.hidden=i!==this.index);
   this.querySelector('[data-scene-next]')?.addEventListener('click',()=>this.show(this.index+1),options);
   this.querySelector('[data-scene-previous]')?.addEventListener('click',()=>this.show(this.index-1),options);
   this.tabs.forEach((t,i)=>t.addEventListener('click',()=>this.show(i),options));
   this.querySelector('[role="tablist"]')?.addEventListener('keydown',e=>{
    const i=this.tabs.indexOf(e.target.closest('[data-scene-tab]'));
    if(i<0||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
    e.preventDefault();
    const n=e.key==='Home'?0:e.key==='End'?this.slides.length-1:i+(e.key==='ArrowRight'?1:-1);
    this.show(n);this.tabs[this.index].focus();
   },options);
   const stage=this.querySelector('[data-scene-stage]');
   stage?.addEventListener('pointerdown',e=>{
    if(e.pointerType==='mouse'||!e.isPrimary||e.target.closest('button'))return;
    this.pointer={x:e.clientX,y:e.clientY,id:e.pointerId};
   },options);
   stage?.addEventListener('pointercancel',()=>this.pointer=null,options);
   stage?.addEventListener('pointerup',e=>{
    if(!this.pointer||this.pointer.id!==e.pointerId)return;
    const dx=e.clientX-this.pointer.x,dy=e.clientY-this.pointer.y;this.pointer=null;
    if(Math.abs(dx)<48||Math.abs(dx)<Math.abs(dy)*1.25)return;
    this.swipeUntil=Date.now()+350;this.show(this.index+(dx<0?1:-1));
   },options);
   stage?.addEventListener('click',e=>{if(Date.now()<this.swipeUntil){e.preventDefault();e.stopPropagation();}},{...options,capture:true});
   document.addEventListener('shopify:block:select',e=>{
    const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail?.blockId);
    if(i>=0)this.show(i,false);
   },options);
   this.classList.add('is-ready');
  }
  disconnectedCallback(){this.abort?.abort();this.animation?.cancel();}
  show(index,animate=true){
   if(!this.slides?.length)return;
   const n=(index+this.slides.length)%this.slides.length;
   if(n===this.index)return;
   const previous=this.slides[this.index],next=this.slides[n];
   const focused=previous.contains(document.activeElement);
   const direction=index>this.index?1:-1;
   this.animation?.cancel();previous.hidden=true;next.hidden=false;this.index=n;
   this.tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===n));t.tabIndex=i===n?0:-1;});
   const number=String(n+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
   this.querySelector('[data-scene-count]').textContent=number;
   this.querySelector('[data-scene-status]').textContent=this.tabs[n].textContent.trim()+', '+(n+1)+' / '+this.slides.length;
   if(focused)next.focus({preventScroll:true});
   if(animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&next.animate)
    this.animation=next.animate([{opacity:.45,transform:'translateX('+direction*8+'px)'},{opacity:1,transform:'translateX(0)'}],{duration:320,easing:'cubic-bezier(.2,.65,.25,1)'});
  }
 });
})();

